import styled from 'styled-components';
import {Pagination} from '@mui/material';

export const StyledPagination = styled(Pagination)`
  ${({theme})=>`
    display: flex;
    justify-content: center;
    margin: ${theme.uptimeSpace[10]}px 0;
    .MuiPaginationItem-page{
      font-weight: 600;
    }
  `} 
`